import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesGenerateAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesGenerateAction() {
  return fetchApi('/v1/fc_api/feeding_guidelines_generate_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesGenerateAction;
